export function LiveBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-wider text-[#D92D20] bg-[#D92D20]/10 px-3 py-1 rounded-sm border border-[#D92D20]/30 ${className}`}
      data-testid="live-badge"
    >
      <span className="w-2 h-2 rounded-full bg-[#D92D20] live-dot" />
      Live
    </span>
  );
}

export function StatusBadge({ status }) {
  if (status === "live") return <LiveBadge />;
  const map = {
    upcoming: "text-[#0090A8] bg-[#0090A8]/10 border-[#0090A8]/30",
    ended: "text-[#71717A] bg-black/5 border-black/10",
    cancelled: "text-[#D92D20] bg-black/5 border-black/10 line-through",
  };
  return (
    <span
      className={`inline-flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-wider px-3 py-1 rounded-sm border ${map[status] || map.ended}`}
      data-testid={`status-badge-${status}`}
    >
      {status}
    </span>
  );
}
